import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cryptoApiHeaders = {
  "X-RapidAPI-Key": "91ee9e1306msh142cdfa6118c7e9p1f61b7jsn44ef20451ad7",
  "X-RapidAPI-Host": "coinranking1.p.rapidapi.com",
};
const baseUrl = "https://coinranking1.p.rapidapi.com";

const createRequest = (url) => ({ url, headers: cryptoApiHeaders });

export const cryptoApi = createApi({
  reducerPath: "cryptoApi", //the name
  baseQuery: fetchBaseQuery({ baseUrl }),
  //function que recibe el objeto url

  endpoints: (builder) => ({
    //nuestros endpoins
    //1
    getCryptos: builder.query({
      query: (count) => createRequest(`/coins?limit=${count}`),
    }),
    //2
    getCryptoDetails: builder.query({
      query: (coinId) => createRequest(`/coin/${coinId}`),
    }),
    
    getCryptoHistory: builder.query({
      query: ({coinId, timeperiod}) => createRequest(`coin/${coinId}/history?timePeriod=${timeperiod}`),
    }),
  }),
});
export const { useGetCryptosQuery, useGetCryptoDetailsQuery, useGetCryptoHistoryQuery } = cryptoApi;

/* const options = {
    method: 'GET',
    url: 'https://coinranking1.p.rapidapi.com/coins',
    params: {
      referenceCurrencyUuid: 'yhjMzLPhuIDl',
      timePeriod: '24h',
      'tiers[0]': '1',
      orderBy: 'marketCap',
      orderDirection: 'desc',
      limit: '50',
      offset: '0'
    },
    headers: {
      'X-RapidAPI-Key': '91ee9e1306msh142cdfa6118c7e9p1f61b7jsn44ef20451ad7',
      'X-RapidAPI-Host': 'coinranking1.p.rapidapi.com'
    }
  }; */
